// extracted by mini-css-extract-plugin
export var active = "_2x-2";
export var highlight = "_2x-1";
export var highlightLayer = "_2x-0";
export var issuePopover = "_2x-3";
export var statusIcon = "_2x-4";